import styled from 'styled-components'

export const Container = styled.div`
  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-brand);
  padding: var(--space-400) var(--space-500);
`

export const Separator = styled.div`
  margin: var(--space-200) 0;
  width: 100%;
  height: 1px;
  background: var(--border-secondary);
`
